module.exports = __webpack_public_path__ + "img/leesh0001_1.045a4373.svg";